import { authHeader } from '../utils/auth-header';
import apis from '../config/api';
import axios from "axios";

export const pricingService = {
    getPrice,
};


function getPrice(request){
    return axios.post(`${apis.pricing}`, request,{ headers: authHeader() });
}




// WEBPACK FOOTER //
// ./src/services/pricingService.js